import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const appleBusinessManager = defineConnector({
  identifier: "appleBusinessManager",
  name: "Apple Business Manager",
  tagLine: "Device and content management for organizations",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api-business\\.apple\\.com/.*",
  auth: customAuth("appleBusinessManager"),
  steps: [
    {
      title: "Create an API account in Apple Business Manager",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Apple Business Manager](https://business.apple.com), go to **Settings › API**, and create an API account. Download the private key and note your client ID and key ID.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          helperText: "The client ID generated when you create an API account.",
          target: { kind: "configuration", field: "clientId" },
        },
        {
          kind: "input",
          label: "Key ID",
          required: true,
          helperText: "The key ID generated when you create an API account.",
          target: { kind: "configuration", field: "keyId" },
        },
        {
          kind: "input",
          label: "Private key",
          required: true,
          helperText:
            "The EC private key in PEM format, used to sign the client assertion JWT.",
          target: { kind: "secrets", field: "privateKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api-business.apple.com/v1/server/devices",
  },
});
